import { useMemo } from 'react';

const useFooter = ({ disabled, isLoading }) => {
  const isDisabled = useMemo(
    () => ({
      disabled: isLoading || disabled,
      loading: isLoading,
    }),
    [disabled, isLoading],
  );

  return {
    isDisabled,
  };
};

export default useFooter;
